module.exports = __webpack_public_path__ + "static/media/medium.e05a9d03.svg";